import { render, staticRenderFns } from "./ProfilePurchaseIcon.vue?vue&type=template&id=0e7e3c44&scoped=true"
import script from "./ProfilePurchaseIcon.vue?vue&type=script&lang=ts"
export * from "./ProfilePurchaseIcon.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePurchaseIcon.vue?vue&type=style&index=0&id=0e7e3c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e3c44",
  null
  
)

export default component.exports